import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { HttpClientModule } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { importProvidersFrom } from '@angular/core';
//import {  } from './app/app-routing.module';
import { appRoutes } from './app/app.routes';
import { BrowserModule } from '@angular/platform-browser';
import { ModalModule } from 'ngx-bootstrap/modal';
import { provideAnimations } from '@angular/platform-browser/animations';
//import { provideNebular, NbThemeModule } from '@nebular/theme';
import { NbThemeModule } from '@nebular/theme';
import { NbSidebarService } from '@nebular/theme';
import { NbMenuService } from '@nebular/theme';
import { NbMenuModule  } from '@nebular/theme';
import { NbDialogService  } from '@nebular/theme';
import { NbDialogModule } from '@nebular/theme';
import { AngularSlickgridModule } from 'angular-slickgrid';

//Grilla ag Grid
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community'; 
ModuleRegistry.registerModules([AllCommunityModule]);
//end Grilla ag Grid 

if (environment.production) {
  enableProdMode();
}

// bootstrapApplication(AppComponent)
//   .catch(err => console.error(err));

  bootstrapApplication(AppComponent, {
    providers: [
      provideRouter(appRoutes),
      importProvidersFrom(BrowserModule),
      importProvidersFrom(ModalModule.forRoot()),
      importProvidersFrom(HttpClientModule), // 👈 necesario para que funcione HttpClient
      provideAnimations(),
      importProvidersFrom(NbThemeModule.forRoot({ name: 'default' })) ,
      NbSidebarService,
      NbMenuService,
      NbDialogService,
      importProvidersFrom(NbDialogModule.forRoot()),
      importProvidersFrom(NbMenuModule.forRoot()),
      importProvidersFrom(AngularSlickgridModule.forRoot()),
    ]
  });
// import { enableProdMode } from '@angular/core';
// import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

// import { AppModule } from './app/app.module';
// import { environment } from './environments/environment';


// if (environment.production) {
//   enableProdMode();
// }

// platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.error(err));
